import { FC, ReactNode, SVGProps } from 'react'
import styles from './overviewStatCard.module.scss'

interface OverviewStatCardProps {
  // "vs previous period" badge (a TrendBadge), shown beside the value.
  badge?: ReactNode
  children?: ReactNode
  icon: FC<SVGProps<SVGSVGElement>>
  // Data is still being collected: shows a "Processing" pill instead of the
  // value.
  pending?: boolean
  // Pins the value row to the bottom of the card (Total Users has no body).
  pinValueToBottom?: boolean
  // 'large' is the first overview row (Chats / Messages / Sources), 'compact'
  // the second (Users / New vs Returning / Organic vs Paid).
  size: 'compact' | 'large'
  title: string
  // null renders a dash: the figure is not available (yet) for this range,
  // which is not the same as a count of 0.
  value: number | null
}

export const OverviewStatCard: FC<OverviewStatCardProps> = ({
  badge,
  children,
  icon: Icon,
  pending = false,
  pinValueToBottom = false,
  size,
  title,
  value,
}) => (
  <div className={`${styles.card} ${styles[size]}`}>
    <div className={styles.header}>
      <Icon className={styles.icon} />
      <h3 className={styles.title}>{title}</h3>
    </div>
    <div
      className={`${styles.valueRow} ${pinValueToBottom ? styles.pinned : ''}`}
    >
      {pending ? (
        <span className={styles.processing}>
          <span className={styles.processingDot} />
          Processing
        </span>
      ) : (
        <>
          <span className={styles.value}>
            {value === null ? '–' : value.toLocaleString('en-US')}
          </span>
          {value !== null && badge}
        </>
      )}
    </div>
    {children}
  </div>
)
